import React from "react";
import "./GenreInput.css";

export const GenreInput = ({genre, setGenre}) => {
    return (
        <>
            <h1 className={"extra_text"}>Laissez-moi percer un peu plus en vous, dévoilez-moi votre essence...</h1>
            <div className={"genre-container"}>
                <button className={genre === "Homme" ? "genre-button" : "disabled-genre-button"} onClick={() => setGenre("Homme")}>HOMME</button>
                <button className={genre === "Femme" ? "genre-button" : "disabled-genre-button"} onClick={() => setGenre("Femme")}>FEMME</button>
            </div>
        </>
    )
}
